<template>
  <ContentLayout :smallHeader="visibleMedia">
    <template #header>
      <span class="space-right" v-show="visibleMedia">{{ mediaFolder }}</span>
      <h4>{{ !visibleMedia ? 'Fotos / Videos' : (mediaType === 'img' ? 'Fotos' : 'Videos') }}</h4>
      <button v-show="visibleMedia" class="btn space-left" style="top: 15%;" @click="visibleMedia = !visibleMedia">Voltar</button>
    </template>

    <div v-show="!visibleMedia">
      <div class="links">
        <div class="links--item">
          <div v-for="(folder, key) in fotos" :key="key">
            <div style="background: #C6E0B4;" class="links--item-link" @click="showMedia(folder)">{{ folder }}</div>
          </div>
        </div>

        <div class="links--item">
          <div v-for="(folder, key) in videos" :key="key">
            <div style="background: #FFCCCC;" class="links--item-link" @click="showMedia(folder, 'video')">{{ folder }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="visibleMedia">
      <ShowMedia :media_type="mediaType" :media_path="mediaFolder" />
    </div>
  </ContentLayout>
</template>

<script>
import ContentLayout from '../components/ContentLayout.vue';
import ShowMedia from '../components/ShowMedia.vue';

export default {
  components: {
    ShowMedia,
    ContentLayout
  },
  data: () => ({
    fotos: [],
    videos: [],
    visibleMedia: false,
    mediaType: null,
    mediaFolder: null
  }),
  methods: {
    showMedia(folder, type = 'img') {
      this.mediaType = type;
      this.mediaFolder = folder;
      this.visibleMedia = !this.visibleMedia;
    }
  },
  async mounted() {
    const response = await this.$api.mediaDirectories();
    this.fotos = response.data.fotos;
    this.videos = response.data.videos;
  }
};
</script>

<style lang="scss" scoped>
.space-right {
  margin-right: auto;
}

.space-left {
  margin-left: auto;
}

.flex {
  display: flex;
}

.links {
  display: flex;
  justify-content: space-between;

  .links--item {
    width: 49.5%;

    .links--item-link {
      display: block;
      background: #c6e0b4;
      text-align: center;
      border: 1px solid var(--color-mid-blue);
      padding: 10px 15px;
      margin: 4px 0;
      cursor: pointer;

      &.secondary {
        background: #ffcccc;
      }
    }
  }
}

@media (max-width: 900px) {
  .space-right {
    flex-basis: 100%;
    order: 3;
  }
}
</style>
